module.exports = __webpack_public_path__ + "img/carrousel-video-4.d1b9b76f.png";